module.exports = __webpack_public_path__ + "img/logo-white-horizontal.ad3060dc.svg";